/* HoverboardX keuzehulp (hx-keuzehulp.liquid). Sets: URL/prijs/foto per kartkeuze uit data-v/p/i/s/a-*. */
(() => {
  if (customElements.get('hx-keuzehulp')) return;
  const ORDER = ['rider', 'surface', 'seat', 'kart'];
  const P = { b: 'hoverboard-6-5-inch', ob: 'off-road-hoverboard-8-5-inch', s: 'hoverboard-met-hoverkart',
    os: 'off-road-hoverboard-met-hoverkart', k: 'hoverkart', kv: 'hoverkart-met-vering' };

  class HxKeuzehulp extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.a = {};
      this.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b || !this.contains(b)) return;
        const d = b.dataset;
        if (d.q) this.answer(b);
        else if ('back' in d) this.show(ORDER[ORDER.indexOf(this.cur) - 1], true);
        else if ('backResult' in d) this.show(this.a.seat === 'nee' ? 'seat' : 'kart', true);
        else if ('restart' in d) this.restart();
        else if (d.goto) this.show(d.goto, true);
      });
      this.show('rider', false);
    }

    $(s) { return this.querySelector(s); }
    $$(s) { return Array.from(this.querySelectorAll(s)); }

    answer(b) {
      const q = b.dataset.q;
      this.a[q] = b.dataset.v;
      this.$$(`[data-q="${q}"]`).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      if (q === 'seat' && this.a.seat === 'nee') this.clear('kart');
      if (q === 'kart' || (q === 'seat' && this.a.seat === 'nee')) this.result();
      else this.show(ORDER[ORDER.indexOf(q) + 1], true);
    }

    clear(q) {
      delete this.a[q];
      this.$$(`[data-q="${q}"]`).forEach((x) => x.setAttribute('aria-pressed', 'false'));
    }

    show(step, focus) {
      if (!step) return;
      this.cur = step;
      const n = ORDER.indexOf(step) + 1;
      this.$$('[data-step]').forEach((s) => (s.hidden = s.dataset.step !== step));
      this.$('[data-result]').hidden = true;
      this.$('[data-progress]').hidden = false;
      this.$('[data-nav]').hidden = n === 1;
      this.$('[data-count-text]').textContent = (this.dataset.count || 'Vraag [n]').replace('[n]', n);
      this.$('[data-bar]').style.width = `${n * 25}%`;
      if (focus) this.$(`[data-step="${step}"] .hx-kh__q`).focus();
    }

    result() {
      const a = this.a;
      const off = a.rider === '120' || a.surface === 'ruw';
      const r = [];
      const g = [];
      let p;
      let alt;
      if (a.rider === 'kind') r.push('kind');
      if (a.seat === 'kart') {
        const v = a.kart === 'vering';
        p = v ? P.kv : P.k;
        alt = v ? P.k : P.kv;
        r.push('kartfit', v ? 'kartvering' : a.surface === 'ruw' ? 'kartstdruw' : 'kartstd');
        if (a.rider === '120') r.push('kartheavy');
        g.push('kart');
      } else {
        if (a.rider === '120') r.push('heavy');
        r.push(off ? 'off' : 'std');
        if (a.surface === 'ruw') r.push('ruw');
        else if (!off) r.push('glad');
        g.push('board');
        if (a.seat === 'set') {
          p = off ? P.os : P.s;
          alt = off ? P.ob : P.os;
          r.push('set', a.kart === 'vering' ? 'setvering' : 'setstd');
          g.push('kart');
        } else {
          p = off ? P.ob : P.b;
          alt = off ? P.os : P.ob;
        }
      }
      if (a.rider === 'kind') g.push('kids');

      const names = [];
      const k = a.seat === 'set' && a.kart ? (a.kart === 'vering' ? 'Vering' : 'Std') : '';
      this.$$('[data-product]').forEach((c) => {
        const d = c.dataset;
        const role = d.product === p ? 1 : d.product === alt ? 2 : 0;
        c.hidden = !role;
        c.style.order = role;
        c.classList.toggle('is-primary', role === 1);
        const badge = c.querySelector('[data-badge]');
        if (badge) badge.textContent = role === 1 ? this.dataset.labelPrimary : role === 2 ? this.dataset.labelAlt : '';
        const [link, price, from, img] = ['a', '[data-price]', '[data-from]', 'img'].map((q) => c.querySelector(q));
        if (!('href0' in d)) Object.assign(d, { href0: link.getAttribute('href'), price0: price.textContent }, img && { src0: img.src, set0: img.srcset, alt0: img.alt });
        const vUrl = k && d['v' + k];
        const iUrl = k && d['i' + k];
        if (link) link.setAttribute('href', vUrl || d.href0);
        if (price) price.textContent = (vUrl && d['p' + k]) || d.price0;
        if (from) from.hidden = !!vUrl;
        if (img) Object.assign(img, { srcset: (iUrl && d['s' + k]) || d.set0, src: iUrl || d.src0, alt: (iUrl && d['a' + k]) || d.alt0 });
        if (role && link) names[role - 1] = `${badge ? badge.textContent : ''}: ${link.textContent.trim()}`;
      });
      this.$$('[data-r]').forEach((li) => (li.hidden = !r.includes(li.dataset.r)));
      this.$$('[data-g]').forEach((li) => (li.hidden = !g.includes(li.dataset.g)));

      const list = this.$('[data-answers]');
      list.textContent = '';
      ORDER.forEach((q) => {
        const t = a[q] && this.$(`[data-q="${q}"][aria-pressed="true"] [data-title]`);
        if (!t) return;
        const li = document.createElement('li');
        const btn = document.createElement('button');
        Object.assign(btn, { type: 'button', className: 'hx-kh__chip' }).dataset.goto = q;
        btn.innerHTML = '<span class="visually-hidden">Wijzig: </span>';
        btn.append(t.textContent.trim());
        li.append(btn);
        list.append(li);
      });

      [...this.$$('[data-step]'), this.$('[data-progress]'), this.$('[data-nav]')].forEach((x) => (x.hidden = true));
      this.$('[data-result]').hidden = false;
      this.cur = 'result';
      this.$('[data-live]').textContent = names.filter(Boolean).join('. ');
      this.$('[data-result] .hx-kh__q').focus();
    }

    restart() {
      ORDER.forEach((q) => this.clear(q));
      this.$('[data-live]').textContent = '';
      this.show('rider', true);
    }
  }

  customElements.define('hx-keuzehulp', HxKeuzehulp);
})();
